export const localeText = {
  // Traduções padrão
  page: "Página",
  more: "Mais",
  to: "até",
  of: "de",
  next: "Próxima",
  last: "Última",
  first: "Primeira",
  previous: "Anterior",
  loadingOoo: "Carregando...",
  selectAll: "Selecionar tudo",
  searchOoo: "Procurar...",
  blanks: "Vazios",
  filterOoo: "Filtrar...",
  equals: "Igual",
  notEqual: "Diferente",
  lessThan: "Menor que",
  greaterThan: "Maior que",
  contains: "Contém",
  notContains: "Não contém",
  startsWith: "Começa com",
  endsWith: "Termina com",
  blank: "Em branco",
  notBlank: "Não em branco",
};
